import { CircularProgress } from '@material-ui/core';
import { Layout } from '@orientaction/components';
import { FC, ReactNode } from 'react';

interface WizardLayoutProps {
  classes: Record<string, string>;
  backLabel: string;
  onBack: () => void;
  title: string;
  step: number;
  totalSteps: number;
  loading?: boolean;
  hideProgress?: boolean;
  bodyClassName?: string;
  footerClassName?: string;
  footer: ReactNode;
  children: ReactNode;
}

const WizardLayout: FC<WizardLayoutProps> = ({
  classes,
  backLabel,
  onBack,
  title,
  step,
  totalSteps,
  loading = false,
  hideProgress = false,
  bodyClassName,
  footerClassName,
  footer,
  children,
}) => {
  const progress = (step / totalSteps) * 100;

  return (
    <Layout isaddBackground={true}>
      <div className={classes.page}>
        <button type="button" className={classes.backLink} onClick={onBack}>
          {backLabel}
        </button>

        <div className={classes.card}>
          <h1 className={classes.title}>{title}</h1>
          {!hideProgress && (
            <>
              <div className={classes.stepLabel}>
                Étape {step} sur {totalSteps}
              </div>
              <div className={classes.progressTrack}>
                <div className={classes.progressFill} style={{ width: `${progress}%` }} />
              </div>
            </>
          )}

          {loading ? (
            <div className={classes.loader}>
              <CircularProgress />
            </div>
          ) : (
            <>
              <div className={bodyClassName}>{children}</div>
              <div className={footerClassName}>{footer}</div>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default WizardLayout;
